import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const ActionsCopyPromptClipboard = declareString(
  "promptLibrary.actionsCopyPromptClipboard",
  {
    text: "Prompt copied",
    comment: `Text that shows in a toast notification when the user clicks on the button to copy the prompt text to their clipboard. 'prompts' is the text input provided to AI model like GPT`,
  }
);

export const ActionsCopyPromptTooltip = declareString(
  "promptLibrary.actionsCopyPromptTooltip",
  {
    text: "Copy prompt",
    comment: `Tooltip that shows on the copy clipboard button. This is an action (verb). When the user clicks on the button to copy the prompt text to their clipboard. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptLinkClipboard = declareString(
  "promptLibrary.actionsPromptLinkClipboard",
  {
    text: "Link copied",
    comment: `Text that shows in a toast notification when the user clicks on the button to copy the prompt link to their clipboard. When the user pastes the link to a browser, the prompt page will be opened. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptLinkClipboardBody = declareString(
  "promptLibrary.actionsPromptLinkClipboardBody",
  {
    text: "Anyone with this link will have access to the prompt",
    comment: `Toast body that shows in a toast notification when the user clicks on the button to copy the prompt link to their clipboard. When the user pastes the link to a browser, the prompt page will be opened. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptLinkTooltip = declareString(
  "promptLibrary.actionsPromptLinkTooltip",
  {
    text: "Share prompt with others",
    comment: `Text that shows in a toast notification when the user clicks on the button to copy the prompt link to their clipboard. When the user pastes the link to a browser, the prompt page will be opened. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptBookmarkTooltip = declareString(
  "promptLibrary.actionsPromptBookmarkTooltip",
  {
    text: "Add to favorite",
    comment: `Tooltip that shows on bookmark button. When the user clicks on the button the prompt is saved to the user's favorite prompt list. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptBookmarkSaved = declareString(
  "promptLibrary.actionsPromptBookmarkSaved",
  {
    text: "Prompt saved",
    comment: `Text that shows in a toast notification when the user clicks on the button to save the prompt. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptBookmarkUnSaved = declareString(
  "promptLibrary.actionsPromptBookmarkUnSaved",
  {
    text: "Prompt unsaved",
    comment: `Text that shows in a toast notification when the user clicks on the button to unsave the prompt. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptBookmarkSavedError = declareString(
  "promptLibrary.actionsPromptBookmarkSavedError",
  {
    text: "Couldn't save prompt, try again later",
    comment: `Text that shows in a toast notification when the user clicks on the button to save the prompt and it fails. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptBookmarkUnSavedError = declareString(
  "promptLibrary.actionsPromptBookmarkUnSavedError",
  {
    text: "Couldn't unsave prompt, try again later",
    comment: `Text that shows in a toast notification when the user clicks on the button to unsave the prompt and it fails. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptDeleteTooltip = declareString(
  "promptLibrary.actionsPromptDeleteTooltip",
  {
    text: "Remove bookmark",
    comment: `Tooltip that shows on delete prompt button. When the user clicks on the button, the prompt is deleted from the user's saved prompts list. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptRemoveTooltip = declareString(
  "promptLibrary.actionsPromptRemoveTooltip",
  {
    text: "Remove from team",
    comment: `Tooltip that shows on delete prompt button. When the user clicks on the button, the prompt is removed from the user's saved prompts list. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsTryInLabel = declareStringWithPlaceholders(
  "promptLibrary.actionsTryInLabel",
  {
    text: ({ productName }) => `Try in ${productName}`,
    placeholders: {
      productName:
        "the name of the product or service, like Business Chat, Word, or Excel",
    },
    comment:
      "Button label for the Copilot prompt's button allowing to try the prompt in a Copilot. Full text could be Try in Business Chat",
  }
);

export const ActionsLikeButtonTooltip = declareString(
  "promptLibrary.actionsLikeButtonTooltip",
  {
    text: "Like",
    comment:
      "Tooltip that's displayed to user when user hovers over the heart icon on a Copilot prompt card to like it",
  }
);

export const ActionsUnLikeButtonTooltip = declareString(
  "promptLibrary.actionsUnLikeButtonTooltip",
  {
    text: "Unlike",
    comment:
      "Tooltip that's displayed to user when user hovers over the heart icon on a Copilot prompt card to unlike it",
  }
);

export const ActionsPromptLiked = declareString(
  "promptLibrary.actionsPromptLiked",
  {
    text: "Prompt liked. See it in 'Your Prompts'.",
    comment: `Text that shows in a toast notification when the user clicks on the button to like the prompt. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptLikedView = declareString(
  "promptLibrary.actionsPromptLikedView",
  {
    text: "Prompt liked. View it in your liked prompts.",
    comment: `Text that shows in a toast notification when the user clicks on the button to like the prompt. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ActionsPromptUnliked = declareString(
  "promptLibrary.actionsPromptUnliked",
  {
    text: "Prompt unliked",
    comment: `Text that shows in a toast notification when the user clicks on the button to unlike the prompt. 'prompts' is the text input provided to AI model like GPT.`,
  }
);
